import AbstractView from "../../../../../shared/src/ranj/equalture/view/AbstractView";
import CacheUtil from "../../../../../shared/lib/html5-software-library/src/ranj/util/CacheUtil";

export default class ItemView extends AbstractView {

    constructor(target) {
        super(target);
        this._target.mouseChildren = false;
        this._target.gotoAndStop(0);
        this._yOrig = this._target.y;
        this._scale = this._target.getChildAt(0).scaleX;
        this.content = null;
    }

    get target() {
        return this._target;
    }

    set content(skin) {
        this._target.removeAllChildren();
        this._content = skin;
        if (skin) {
            this._target.addChild(skin);
            skin._scaleX = skin._scaleY = this._scale;
        }
    }

    get content() {
        return this._content;
    }


    show(bool) {
        this._target.visible = bool;
    }

    cache(bool) {
        if (bool) {
            CacheUtil.cache(this._target);
        } else {
            CacheUtil.uncache(this._target);
        }
    }
}

